var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"category-list"},[_vm._v("\n        "+_vm._s(_vm.waitingList)+"\n        "),_vm._l((_vm.categories_list),function(category){return _c('app-category',{key:category.id,attrs:{"category":category}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ed5d90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/pages/order/CategoryList.vue
// module id = 160
// module chunks = 0